export enum FormDraftStateKey {
  PRESCRIPTION_STEP_1 = 'prescription_step_1',
  PRESCRIPTION_STEP_2_HVLP = 'prescription_step_2_hvlp',
  PRESCRIPTION_STEP_2_IPLP = 'prescription_step_2_iplp',
  PRESCRIPTION_STEP_2_MEDICAMENT_LIST = 'prescription_step_2_medicament_list',
  PRESCRIPTION_STEP_3 = 'prescription_step_3',
  MEDICAL_REPORT = 'medicalReport',
  MEDDI_BABY_REGULAR_EXAMINATION = 'meddi_baby_regular_examination',
  MEDDI_BABY_END_PLAN = 'meddi_baby_end_plan',
  MEDDI_BABY_CREATE_CURRENT_PREGNANCY = 'meddi_baby_create_current_pregnancy',
  MEDDI_BABY_CREATE_PREVIOUS_PREGNANCY = 'meddi_baby_create_previous_pregnancy',
  MEDDI_BABY_CREATE_MOTHERS_HEALTH = 'meddi_baby_create_mothers_health',
  MEDDI_BABY_CREATE_LAB_RESULTS = 'meddi_baby_create_lab_results',
  MEDDI_BABY_CREATE_FINAL_STEP = 'meddi_baby_create_final_step',
}
